import styled, { css } from "styled-components";

const allowScrollbar = css`
  max-width: -webkit-fill-available;
`;

export const ExpressionWrapper = styled.div`
  display: inline-flex;
  align-items: baseline;
  color: ${(props: any) => props.theme["color.text.body"]};
  white-space: normal;
  overflow-x: auto;
  ${allowScrollbar}
  vertical-align: baseline;

  @supports (-moz-appearance: none) {
    max-width: -moz-available;
  }

  &[data-display="block"] {
    display: inline-block;
    padding: 0.8em 0;
    text-align: center;
    width: calc(100% - 1px);
    max-width: 100%;
    overflow-x: auto;
  }

  &[data-display="inline"] .MathJax_SVG svg {
    max-width: none !important;
  }

  svg {
    vertical-align: baseline;
    margin-bottom: 0 !important;

    ${(props: any) =>
      props.isDark &&
      `
      fill: white;

      line {
        stroke: white;
      }
      text {
        fill: white;
      }
    `}
  }

  .react-mathjax-preview-result {
    display: inline;
  }

  &[data-display="block"] .react-mathjax-preview-result {
    overflow-x: auto;
  }
`;

export const serializedStyle = { display: "inline-block", overflowX: "auto", maxWidth: "100%" };
